/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Insurance/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Insurance({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsEditAutopay/Content/SourceInvoice/PaymentPlanType/Insurance"
  
}) {
let constantData = 'Invoice #'
let editAutopayInfoReceivableHumanReadableIdValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'receivable.human_readable_id',
})
let constantData1 = ' - Payor: '
let editAutopayInfoReceivableInsuredInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'receivable.insured.insurance_subscription.insurance_plan.insurance_company.carrier_name',
})
let constantData2 = ' (Group/Plan: '
let editAutopayInfoReceivableInsuredInsuranceSubscriptionInsurancePlanNumberValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'receivable.insured.insurance_subscription.insurance_plan.number',
})
let constantData3 = ')'
let aggregateData = fromAggregate.joinNoSpace(constantData, editAutopayInfoReceivableHumanReadableIdValueData, constantData1, editAutopayInfoReceivableInsuredInsuranceSubscriptionInsurancePlanInsuranceCompanyCarrierNameValueData, constantData2, editAutopayInfoReceivableInsuredInsuranceSubscriptionInsurancePlanNumberValueData, constantData3)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="'Invoice #'"
 data="edit_autopay_info.receivable.human_readable_id"
 aggregate="/Data/aggregate.js joinNoSpace"
 data="' - Payor: '"
 data="edit_autopay_info.receivable.insured.insurance_subscription.insurance_plan.insurance_company.carrier_name"
 data="' (Group/Plan: '"
 data="edit_autopay_info.receivable.insured.insurance_subscription.insurance_plan.number"
 data="')'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}